import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { clockIcon } from '../../icons';
import { AppContext } from '../../../../../../../../../AppModulesWrapper';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';

export const OnlyAfterPremiumExpiration = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(
      generateErrorBannerShowAction('only-after-premium-service-expiration-unavailable-reason-banner-show'),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ErrorWrapper icon={clockIcon}>Дождитесь окончания Премиум-публикации</ErrorWrapper>;
};
